"use strict";

exports.__esModule = true;
exports.default = void 0;

var _paginationNav = require("./pagination-nav");

var _plugins = require("../../utils/plugins");

var components = {
  BPaginationNav: _paginationNav.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/pagination-nav/index.js
// module id = iNir
// module chunks = 14